import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import {CloudflareChallengeService} from "../cloudflare/cloudflare-challenge.service";
import {environment} from "../../../environments/environment";

@Injectable()
export class CloudflareInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        //check for status === 0 is implemented due to cors issues related to waf challenge mode
        if ((this.isCloudflareChallenge(error) || error.status === 0) && environment.cloudflare.turnstileEnabled) {
          console.warn('[CloudflareInterceptor] WAF challenge triggered / cors failure');

          const challengeService = this.injector.get(CloudflareChallengeService);

          // Start Turnstile flow and wait for token
          return from(challengeService.startTurnstileChallenge()).pipe(

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            switchMap((token: string) => {
              const retriedReq = req.clone({
                setHeaders: {
                  'X-Retried-With-Turnstile': 'true'
                },
                withCredentials: true,
              });

              return next.handle(retriedReq);
            })
          );
        }

        return throwError(() => error);
      })
    );
  }

  private isCloudflareChallenge(error: HttpErrorResponse): boolean {

    return error.headers.has('cf-mitigated') &&
      error.headers.get('cf-mitigated') === 'challenge' &&
      ! error.headers.has('X-Retried-With-Turnstile');
  }
}
